<template>
  <ibox>
    <template slot="title">会員情報詳細</template>
    <template slot="body">
      <MemberForm :id="memberId"></MemberForm>
    </template>
  </ibox>
</template>

<script>
  import MemberForm from '../../components/member/Form.vue'
  export default {
    data () {
      return {
        memberId: this.$route.params.member_id
      }
    },
    components: {
      MemberForm
    }
  }
</script>




// WEBPACK FOOTER //
// Edit.vue?388a2ec4